import { SUBMIT_ANSWER, SUBMIT_ANSWER_SUCCESS } from 'actionTypes';

export function submitAnswer(questionId, answers) {
  return {
    type: SUBMIT_ANSWER,
    endpointArgs: { questionId },
    payload: { value: answers },
    answer: { [questionId]: answers },
  };
}

export function submitAnswerSuccess(response) {
  return {
    type: SUBMIT_ANSWER_SUCCESS,
  };
}



// WEBPACK FOOTER //
// ./src/actions/answerActions.js